import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/modules/auth/useAuth';
import { ROUTES } from '@/config/routes';

/**
 * /logout — convenience URL. Calls signOut, also clears the moderator
 * cache + Supabase auth token explicitly so a stuck tab can recover by
 * typing the URL, then bounces to the landing page.
 */
export const LogoutPage = () => {
  const { logOut } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await logOut();
      } catch {
        // ignore — we'll still clear storage and bounce.
      }
      try {
        // Belt + braces: clear anything that could keep the session alive.
        window.sessionStorage.removeItem('hottr.is_moderator');
        // Supabase persists its session in localStorage under a key prefixed
        // with `sb-…-auth-token` — clear every match.
        for (let i = window.localStorage.length - 1; i >= 0; i--) {
          const key = window.localStorage.key(i);
          if (key && key.startsWith('sb-')) window.localStorage.removeItem(key);
        }
        // Mock-mode session marker.
        window.localStorage.removeItem('hottr.auth.session');
      } catch {
        // ignore storage errors
      }
      navigate(ROUTES.landing, { replace: true });
    })();
  }, [logOut, navigate]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-ink text-text-muted">
      <p className="font-display text-[10px] font-bold uppercase tracking-widest">
        Signing out<span className="text-pink">.</span>
      </p>
    </div>
  );
};
